var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_11)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 230.029V262.029C368 279.002 361.257 295.281 349.255 307.283C337.252 319.286 320.974 326.029 304 326.029H272V361.609L144 315.899V166.029C144 151.779 161.22 144.639 171.31 154.719L198.59 182.029H252.22C263.13 182.029 275.97 189.949 280.84 199.719L288 214.029H352C356.243 214.029 360.313 215.714 363.314 218.715C366.314 221.715 368 225.785 368 230.029ZM256 230.029C256 226.864 255.062 223.771 253.304 221.139C251.545 218.508 249.047 216.458 246.123 215.247C243.199 214.036 239.982 213.719 236.879 214.336C233.775 214.953 230.924 216.477 228.686 218.715C226.449 220.953 224.925 223.803 224.307 226.907C223.69 230.011 224.007 233.228 225.218 236.152C226.429 239.075 228.48 241.574 231.111 243.332C233.742 245.09 236.836 246.029 240 246.029C244.243 246.029 248.313 244.343 251.314 241.342C254.314 238.342 256 234.272 256 230.029Z",
    fill: "#B9BECA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.740e784d1b49ea3b96d926c405496b02.svg";
export { ForwardRef as ReactComponent };